<template>
  <section
    class="tw-flex tw-h-screen tw-items-center tw-justify-center tw-text-center"
  >
    <div v-if="showError" class="tw-flex tw-m-auto tw-flex-col">
      <p>
        {{ $t("error") }}
      </p>

      <div class="tw-flex tw-cursor-pointer tw-relative">
        <div class="tw-flex tw-z-10 tw-items-center">
          <a
            class="tw-text-primary-grey-700"
            @click="errorInDetail = !errorInDetail"
          >
            {{ $t("m365-show-error") }}
          </a>
          <cb-icon-chevron-down
            :width="16"
            class="tw-transition-transform tw-text-primary-grey-700"
            :class="errorInDetail ? 'tw-rotate-180' : 'tw-rotate-0'"
          />
        </div>
        <div
          v-if="errorInDetail"
          class="tw-absolute tw-top-0 tw-z-0 tw-flex tw-flex-col"
        >
          <p v-if="error">
            <span class="tw-font-bold">Error: </span> {{ error }}
          </p>
          <p v-if="errorDescription">
            <span class="tw-font-bold">Error Description: </span
            >{{ errorDescription }}
          </p>
        </div>
      </div>
    </div>
    <div v-else>
      {{ $t("success") }}
      <p>
        {{ $t("page-close-countdown") }}
        <span id="countdowntimer">5 </span>
        {{ $t("page-close-seconds") }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import { persistConsentResult, clearConsentResult } from "@/utils/consent";

type RouteQuery = {
  success?: string;
  orgID?: string;
  error?: string;
  errorDescription?: string;
};

const showError = ref(false);
const errorInDetail = ref(true);
const error = ref("");
const errorDescription = ref("");

const route = useRoute();

const startCountdown = (): void => {
  let timeleft = 5;
  const downloadTimer = setInterval(() => {
    timeleft--;

    const countdownEl = document.getElementById("countdowntimer");
    if (countdownEl) {
      countdownEl.textContent = timeleft.toString();
    }

    if (timeleft <= 0) {
      clearInterval(downloadTimer);
      window.close();
    }
  }, 1000);
};

onMounted(() => {
  const query = route.query as RouteQuery;
  const ndrChannel = new BroadcastChannel("ndr-connection");

  if (query.success === "true") {
    // A successful outcome is recovered by the opener re-fetching the onboarding
    // status, so no persisted result is needed here — just clear any stale one.
    clearConsentResult();
    ndrChannel.postMessage({ success: true, orgID: query.orgID });
  } else {
    // Persist the failure before broadcasting: the popup auto-closes right after
    // this, and the BroadcastChannel message can be lost in that race. The
    // opener reads this persisted result once the popup closes.
    persistConsentResult({
      success: false,
      error: query.error || "",
      errorDescription: query.errorDescription || "",
    });
    ndrChannel.postMessage({
      success: false,
      error: query.error || "",
      errorDescription: query.errorDescription || "",
    });
    showError.value = true;
    error.value = query.error || "";
    errorDescription.value = query.errorDescription || "";
  }

  if (query.success) {
    startCountdown();
  }
});
</script>
